import React, { FC, useState } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useGetClientProfileTab } from '../../../../../../../api/queries/useGetClientProfileTab';
import { isFemaleProfile } from 'src/utils/genderUtils';
import { InjuriesNotesModal } from './ClientProfileTab/InjuriesNotesModal';

import InjurieslimitationsMaleNeckIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-neck.webp';
import InjurieslimitationsMaleShouldersIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp';
import InjurieslimitationsMaleChestIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-chest.webp';
import InjurieslimitationsMaleCoreIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-core.webp';
import InjurieslimitationsMaleBackIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-back.webp';
import InjurieslimitationsMaleWristsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp';
import InjurieslimitationsMaleElbowIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp';
import InjurieslimitationsMaleArmsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-arms.webp';
import InjurieslimitationsMaleHipsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-hips.webp';
import InjurieslimitationsMaleKneesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-knees.webp';
import InjurieslimitationsMaleAnklesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp';
import InjurieslimitationsMaleGlutesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp';
import InjurieslimitationsFemaleNeckIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-neck.webp';
import InjurieslimitationsFemaleShouldersIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp';
import InjurieslimitationsFemaleChestIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-chest.webp';
import InjurieslimitationsFemaleCoreIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-core.webp';
import InjurieslimitationsFemaleBackIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-back.webp';
import InjurieslimitationsFemaleWristsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp';
import InjurieslimitationsFemaleElbowIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp';
import InjurieslimitationsFemaleArmsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-arms.webp';
import InjurieslimitationsFemaleHipsIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-hips.webp';
import InjurieslimitationsFemaleKneesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-knees.webp';
import InjurieslimitationsFemaleAnklesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp';
import InjurieslimitationsFemaleGlutesIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp';
import InjurieslimitationsFemalePregnancyIcon from 'url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp';

import { ReactComponent as Client_profileIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg';
import { ReactComponent as Injuries_notesIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg';
import { ReactComponent as EditIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg';

import BodyMetricsCompositionFemale from 'url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-female.png';
import BodyMetricsCompositionMale from 'url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-male.png';
import { ReactComponent as BodyMetricsCompositionIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition.svg';
import { ReactComponent as ProgressPhotosIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/programs/progress-photos.svg';
import { ReactComponent as AddProgressPhotosIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/programs/add-progress-photos.svg';

import ProgressFrontPlaceholder from 'url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/front.jpg';
import ProgressSidePlaceholder from 'url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/side.jpg';
import ProgressBackPlaceholder from 'url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/back.jpg';

import { MovementProgressionChart } from './MovementProgressionChart';

const SHOW_PROGRESS_SECTION = false;

interface ClientProfileTabProps {
  client?: any;
}

const mapActivityLevel = (level: number | string | null | undefined) => {
  if (level === null || level === undefined || level === '' || level === 'No data') {
    return 'No data';
  }
  const num = Number(level);
  if (isNaN(num)) return 'No data';
  if (num < 30) return 'Lightly Active';
  if (num < 70) return 'Moderately Active';
  return 'Very Active';
};

const mapEnergyLevel = (level?: string | null) => {
  if (!level || level === 'No data') return 'No data';
  const norm = level.toLowerCase().replace(/_/g, '-');
  if (norm === 'often-low') return 'Often Low';
  if (norm === 'often-high') return 'Often High';
  if (norm === 'fluctuates') return 'Fluctuates';
  return toTitleCase(level);
};

const mapFitnessLevel = (level?: string | null) => {
  if (!level || level === 'No data') return 'No data';
  switch (level.toLowerCase().replace(/_/g, '-')) {
    case 'beginner':
      return 'Beginner';
    case 'early-intermediate':
      return 'Early Intermediate';
    case 'intermediate':
      return 'Intermediate';
    case 'advanced':
      return 'Advanced';
    case 'athlete':
      return 'Athlete';
    default:
      return level ? toTitleCase(level) : 'No data';
  }
};

const toTitleCase = (str: string) =>
  str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const renderDots = (value: number, max: number = 6) => {
  return (
    <div className="value-dots">
      {Array.from({ length: max }).map((_, i) => (
        <div key={i} className={`dot ${i < value ? 'purple-100' : 'white-15'}`} />
      ))}
    </div>
  );
};

export const ClientProfileTab: FC<ClientProfileTabProps> = () => {
  const navigate = useNavigate();
  const { client } = useOutletContext<{ client: any }>();
  const [isInjuriesModalOpen, setIsInjuriesModalOpen] = useState(false);
  const { data, isLoading } = useGetClientProfileTab(client?.uid || client?.id);
  const isFemale = isFemaleProfile(data?.clientProfile || client);

  const injuryIconMapping: Record<string, React.ReactNode> = {
    neck: (
      <img
        src={isFemale ? InjurieslimitationsFemaleNeckIcon : InjurieslimitationsMaleNeckIcon}
        alt="neck"
        className="program-svg-icon"
      />
    ),
    shoulders: (
      <img
        src={
          isFemale ? InjurieslimitationsFemaleShouldersIcon : InjurieslimitationsMaleShouldersIcon
        }
        alt="shoulders"
        className="program-svg-icon"
      />
    ),
    chest: (
      <img
        src={isFemale ? InjurieslimitationsFemaleChestIcon : InjurieslimitationsMaleChestIcon}
        alt="chest"
        className="program-svg-icon"
      />
    ),
    core: (
      <img
        src={isFemale ? InjurieslimitationsFemaleCoreIcon : InjurieslimitationsMaleCoreIcon}
        alt="core"
        className="program-svg-icon"
      />
    ),
    back: (
      <img
        src={isFemale ? InjurieslimitationsFemaleBackIcon : InjurieslimitationsMaleBackIcon}
        alt="back"
        className="program-svg-icon"
      />
    ),
    wrists: (
      <img
        src={isFemale ? InjurieslimitationsFemaleWristsIcon : InjurieslimitationsMaleWristsIcon}
        alt="wrists"
        className="program-svg-icon"
      />
    ),
    elbow: (
      <img
        src={isFemale ? InjurieslimitationsFemaleElbowIcon : InjurieslimitationsMaleElbowIcon}
        alt="elbow"
        className="program-svg-icon"
      />
    ),
    arms: (
      <img
        src={isFemale ? InjurieslimitationsFemaleArmsIcon : InjurieslimitationsMaleArmsIcon}
        alt="arms"
        className="program-svg-icon"
      />
    ),
    hips: (
      <img
        src={isFemale ? InjurieslimitationsFemaleHipsIcon : InjurieslimitationsMaleHipsIcon}
        alt="hips"
        className="program-svg-icon"
      />
    ),
    knees: (
      <img
        src={isFemale ? InjurieslimitationsFemaleKneesIcon : InjurieslimitationsMaleKneesIcon}
        alt="knees"
        className="program-svg-icon"
      />
    ),
    ankles: (
      <img
        src={isFemale ? InjurieslimitationsFemaleAnklesIcon : InjurieslimitationsMaleAnklesIcon}
        alt="ankles"
        className="program-svg-icon"
      />
    ),
    glutes: (
      <img
        src={isFemale ? InjurieslimitationsFemaleGlutesIcon : InjurieslimitationsMaleGlutesIcon}
        alt="glutes"
        className="program-svg-icon"
      />
    ),
    pregnancy: isFemale ? (
      <img
        src={InjurieslimitationsFemalePregnancyIcon}
        alt="pregnancy"
        className="program-svg-icon"
      />
    ) : null,
  };

  if (isLoading || !data) {
    return (
      <div
        className="program-tab-content client-profile-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
          gap: 16,
        }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 32, color: '#ffa100' }} spin />} />
        <span style={{ fontSize: 16, fontWeight: 500, color: '#ffffffb3' }}>Loading Profile</span>
      </div>
    );
  }

  const { clientProfile, bodyMetrics, progressPhotos } = data;
  const { fitnessLevel, energyLevel, activityLevel } = clientProfile;
  const injuriesPartsRaw = data?.injuriesAndNotes?.parts || [];
  const injuriesParts = injuriesPartsRaw.map((p: any) =>
    typeof p === 'object' && p !== null ? p.slug : p,
  );
  const injuriesNotes = data?.injuriesAndNotes?.notes || '';

  return (
    <div className="program-tab-content client-profile-content">
      <div className="program-cards-grid">
        {/* Client Profile Card */}
        <div className="program-card review-card client-profile-card">
          <div className="card-header">
            <div className="icon">
              <Client_profileIcon />
            </div>
            <h3>Client Profile</h3>
            <button
              className="edit-btn"
              onClick={() =>
                navigate(
                  `/onboarding-trainer/dashboard/program-generator/ai?clientId=${client?.uid || client?.id}&step=energy-level&from=client-profile`,
                )
              }
            >
              <EditIcon style={{ cursor: 'pointer' }} />
            </button>
          </div>
          <div className="card-body">
            <div className="info-row client-profile-row">
              <div className="client-profile-details">
                <span className="value fitness-level-value">{mapFitnessLevel(fitnessLevel)}</span>
                <div className="inline-info">
                  <span className="label">Energy:</span>
                  <span className="value">{mapEnergyLevel(energyLevel)}</span>
                </div>
                <div className="inline-info">
                  <span className="label">Activity:</span>
                  <span className="value">{mapActivityLevel(activityLevel)}</span>
                </div>
              </div>
              <div className="client-profile-graphs">
                <div className="client-profile-chart">
                  {[40, 60, 30, 80, 50, 70, 90].map((h, i) => (
                    <div key={i} className={`bar bar-h${h}`} />
                  ))}
                </div>
                <div className="client-profile-dots">
                  {renderDots(
                    activityLevel != null && activityLevel !== '' && !isNaN(Number(activityLevel))
                      ? Math.min(6, Math.max(1, Math.ceil((Number(activityLevel) / 100) * 6)))
                      : 0,
                    6,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Injuries & Notes Card */}
        <div className="program-card review-card injuries-notes-card">
          <div className="card-header">
            <div className="icon">
              <Injuries_notesIcon />
            </div>
            <h3>Injuries & Notes</h3>
            <button
              className="edit-btn"
              onClick={() =>
                navigate(
                  `/onboarding-trainer/dashboard/program-generator/ai?clientId=${client?.uid || client?.id}&step=injuries-limitations&from=client-profile`,
                )
              }
            >
              <EditIcon style={{ cursor: 'pointer' }} />
            </button>
          </div>
          <div className="card-body injuries-notes-body">
            <div className="injuries-notes">
              <div className="inline-info">
                <span className="value injuries-value">
                  {injuriesParts.length > 0
                    ? injuriesParts.slice(0, 3).map(toTitleCase).join(', ') +
                      (injuriesParts.length > 3 ? '...' : '')
                    : 'None'}
                </span>
              </div>
              {injuriesNotes ? (
                <div className="inline-info">
                  <span className="value notes-value">{injuriesNotes}</span>
                </div>
              ) : (
                <div className="inline-info">
                  <span className="value">No special notes</span>
                </div>
              )}
              {(injuriesParts.length > 3 || (injuriesNotes && injuriesNotes.trim().length > 0)) && (
                <div className="show-more-toggle" onClick={() => setIsInjuriesModalOpen(true)}>
                  Show More
                </div>
              )}
            </div>
            {injuriesParts.length > 0 && (
              <div className="injuries-notes-image">
                <div className="stacked-images">
                  {injuriesParts
                    .slice(0, 3)
                    .reverse()
                    .map((part, i) => (
                      <div
                        className={`stacked-img stack-${injuriesParts.slice(0, 3).length - 1 - i}`}
                        key={part}
                      >
                        {injuryIconMapping[part]}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Body Metrics & Composition */}
        <div className="program-card review-card body-metrics-card">
          <div className="card-header">
            <div className="icon">
              <BodyMetricsCompositionIcon />
            </div>
            <h3>Body Metrics & Composition</h3>
            <button className="edit-btn">
              <EditIcon />
            </button>
          </div>
          <div className="card-body body-metrics-body">
            <div className="body-model-container">
              <img
                src={isFemale ? BodyMetricsCompositionFemale : BodyMetricsCompositionMale}
                alt="Body Metrics Model"
              />
            </div>
            <div className="metrics-grid">
              <div className="metric-badge">
                <span className="label">Waist:</span>
                <span className="value">{bodyMetrics.waist || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Weight:</span>
                <span className="value">{bodyMetrics.weight || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Chest:</span>
                <span className="value">{bodyMetrics.chest || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Height:</span>
                <span className="value">{bodyMetrics.height || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Hip:</span>
                <span className="value">{bodyMetrics.hip || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Body Fat:</span>
                <span className="value">{bodyMetrics.bodyFat || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Arms:</span>
                <span className="value">{bodyMetrics.arms || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Lean Mass:</span>
                <span className="value">{bodyMetrics.leanMass || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Thighs:</span>
                <span className="value">{bodyMetrics.thighs || 'No Data'}</span>
              </div>
              <div className="metric-badge">
                <span className="label">Age:</span>
                <span className="value">{bodyMetrics.age || 'No Data'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Progress Photos */}
        {SHOW_PROGRESS_SECTION && (
          <div className="program-card review-card progress-photos-card">
            <div className="card-header">
              <div className="icon">
                <ProgressPhotosIcon />
              </div>
              <h3>Progress Photos</h3>
              <button className="edit-btn add-btn">
                <AddProgressPhotosIcon />
              </button>
            </div>
            <div className="card-body progress-photos-body">
              <div className="photos-row">
                {progressPhotos.photos.map((photo, i) => {
                  const getLocalImage = (type: string) => {
                    if (type === 'front') return ProgressFrontPlaceholder;
                    if (type === 'side') return ProgressSidePlaceholder;
                    return ProgressBackPlaceholder;
                  };
                  return (
                    <div className="photo-container" key={i}>
                      <div className="photo-frame">
                        <img src={photo.url || getLocalImage(photo.type)} alt={photo.label} />
                        <span className="photo-label">{photo.label}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="last-updated">
                <span className="label">Last updated:</span>
                <span className="value"> {progressPhotos.lastUpdated}</span>
              </div>
              <button className="view-all-btn">View All Photos</button>
            </div>
          </div>
        )}
        {data?.movementProgression?.baseValues &&
          data.movementProgression.baseValues.length > 0 && (
            <MovementProgressionChart
              baseValues={data.movementProgression.baseValues}
              legendData={data.movementProgression.legendData || []}
            />
          )}
      </div>

      <InjuriesNotesModal
        isOpen={isInjuriesModalOpen}
        onClose={() => setIsInjuriesModalOpen(false)}
        injuriesParts={injuriesParts}
        injuriesNotes={injuriesNotes}
        injuryIconMapping={injuryIconMapping}
        toTitleCase={toTitleCase}
      />
    </div>
  );
};
